import {NgModule} from '@angular/core';
import {HcConfigPage} from "./page/overview/hc-config/hc-config.page";
import {
    IntegrationTypeFullComponent
} from "./component/object-components/integration-type-object-base-component/view/full/integration-type-full.component";
import {
    IntegrationTypeSideComponent
} from "./component/object-components/integration-type-object-base-component/view/side/integration-type-side.component";
import {
    IntegrationTypeBaseComponent
} from "./component/object-components/integration-type-object-base-component/view/integration-type-base.component";
import {
    IntegrationTypeObjectBaseComponent
} from "./component/object-components/integration-type-object-base-component/integration-type-object-base.component";

import {DragDropModule} from 'primeng/dragdrop';
import {
    IntegrationAdapterTypeObjectBaseComponent
} from "./component/object-components/integration-adapter-type-object-base-component/integration-adapter-type-object-base.component";
import {
    IntegrationAdapterTypeBaseComponent
} from "./component/object-components/integration-adapter-type-object-base-component/view/integration-adapter-type-base.component";
import {
    IntegrationAdapterTypeSideComponent
} from "./component/object-components/integration-adapter-type-object-base-component/view/side/integration-adapter-type-side.component";
import {
    IntegrationAdapterTypeFullComponent
} from "./component/object-components/integration-adapter-type-object-base-component/view/full/integration-adapter-type-full.component";
import {
    IntegrationTypeStepObjectBaseComponent
} from "./component/object-components/integration-type-step-object-base-component/integration-type-step-object-base.component";
import {
    IntegrationTypeStepBaseComponent
} from "./component/object-components/integration-type-step-object-base-component/view/integration-type-step-base.component";
import {
    IntegrationTypeStepSideComponent
} from "./component/object-components/integration-type-step-object-base-component/view/side/integration-type-step-side.component";
import {
    IntegrationTypeStepFullComponent
} from "./component/object-components/integration-type-step-object-base-component/view/full/integration-type-step-full.component";
import {HC_ENTITY_PROVIDER} from "./hc.entity-provider";
import {CoreModule} from "../../core/core.module";
import {HC_TEST_PROVIDERS} from "./test/hc-test-definition";

@NgModule({
  declarations: [
    HcConfigPage,
    IntegrationTypeFullComponent,
    IntegrationTypeSideComponent,
    IntegrationTypeBaseComponent,
    IntegrationTypeObjectBaseComponent,
    IntegrationAdapterTypeObjectBaseComponent,
    IntegrationAdapterTypeBaseComponent,
    IntegrationAdapterTypeSideComponent,
    IntegrationAdapterTypeFullComponent,
    IntegrationTypeStepObjectBaseComponent,
    IntegrationTypeStepBaseComponent,
    IntegrationTypeStepSideComponent,
    IntegrationTypeStepFullComponent,
  ],
  exports:[
    HcConfigPage,
    IntegrationTypeFullComponent,
    IntegrationTypeSideComponent,
    IntegrationTypeBaseComponent,
    IntegrationTypeObjectBaseComponent,
    IntegrationAdapterTypeObjectBaseComponent,
    IntegrationAdapterTypeBaseComponent,
    IntegrationAdapterTypeSideComponent,
    IntegrationAdapterTypeFullComponent,
    IntegrationTypeStepObjectBaseComponent,
    IntegrationTypeStepBaseComponent,
    IntegrationTypeStepSideComponent,
    IntegrationTypeStepFullComponent,
  ],
  imports: [
    CoreModule,
    DragDropModule,

  ],
  providers: [HC_ENTITY_PROVIDER, HC_TEST_PROVIDERS]
})
export class HcModule { }
 
 
 
